import { IProductDetail } from "../interfaces/shopify";
import { client } from "./shopifyClient";

export const getProductDetail = async (
  handle: string
): Promise<IProductDetail | null> => {
  const query = `
    query getProductWithExtraVariants($handle: String!) {
      productByHandle(handle: $handle) {
        id
        title
        descriptionHtml
        productType
        images(first: 20) {
          edges {
            node {
              url
              altText
            }
          }
        }
        collections(first: 100) {
          edges {
            node {
              id
              title
              handle
            }
          }
        }
        variants(first: 100) {
          edges {
            node {
              id
              title
              selectedOptions {
                name
                value
              }
              price {
                amount
                currencyCode
              }
                  compareAtPrice {
                  amount
                  currencyCode
              }
            }
          }
        }

      productVariantMetafield: metafield(namespace: "custom", key: "product_variant") {
          value
          type
          references(first: 50) {
            edges {
              node {
                __typename
                ... on Product {
                  id
                  title
                  variants(first: 100) {
                    edges {
                      node {
                        id
                        title
                        availableForSale
                        quantityAvailable
                        selectedOptions {
                          name
                          value
                        }
                        price {
                          amount
                          currencyCode
                        }
                        compareAtPrice {
                          amount
                          currencyCode
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      
        fileDetail: metafield(namespace: "custom", key: "image_detail") {
          type
          value
          references(first: 10) {
            edges {
              node {
                __typename
                ... on Metaobject {
                  id
                  type
                  fields {
                    key
                    value
                    reference {
                      __typename
                      ... on MediaImage {
                        image {
                          url
                          altText
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }

        titleDetail: metafield(namespace: "custom", key: "title_detail") {
          type
          value
          references(first: 10) {
            edges {
              node {
                __typename
                ... on Metaobject {
                  id
                  type
                  fields {
                    key
                    value
                    reference {
                      __typename
                      ... on MediaImage {
                        image {
                          url
                          altText
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }



      }
    }
  `;

  const { data } = await client.request<{
    productByHandle: IProductDetail | null;
  }>(query, { variables: { handle } });

  return data?.productByHandle ?? null;
};
